<template>
	<div>
		<form action="https://new.colorwayrb.com/backend/upsreportexe.php" method="POST" class="repGenForm">
			<div class="repGenForm__inputs-wrap">
				<div class="input-group">
					<label for="date_from" class="input-group__label">From:</label>
					<input type="date" id="date_from" name="date_from" class="input-group__input" />
				</div>

				<div class="input-group">
					<label for="date_to" class="input-group__label">To:</label>
					<input type="date" id="date_to" name="date_to" class="input-group__input" />
				</div>

				
			</div>
			
			
			
			<input type="hidden" name="productlist" v-bind:value="JSON.stringify(value) " >
			
			<input
				class="btn btn--blue3 repGenForm__submit"
				type="submit"
				value="Download"
				
			/>
		</form>
	</div>
</template>

<script>
import Vue from "vue";


export default Vue.extend({
	name: "",
	
});
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.repGenForm {
	padding: 20px 0;
	&__inputs-wrap {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 0 30px;
		margin: 0 auto;
	}

	&__submit {
		border-radius: 5px;
		padding: 5px 20px;
		margin: 0 auto;
		display: block;
	}
}

.input-group {
	margin: 0 15px;

	&__label {
		font-weight: 500;
		padding: 5px 0;
		display: block;
		width: 120px;
	}

	&__input,
	&__select {
		border: $border-color 1px solid;
		display: inline-block;
		width: 150px;
		height: 40px;
		padding: 5px;
	}

	&__input {
		padding: 0 0 0 10px;
	}
}
</style>